import React, {useMemo} from "react";
import {Alert, Button, Stack} from "react-bootstrap";
// import {IconBox, ModalSelectIcon, RenderIcon} from "./_components/IconMenu";
import {useAuth} from "../../context";
import {Link, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useGetJson, usePostJson} from "../../hooks";
import {AdminUserAlert, ColumnizeText, PageTitle, SingleText} from "../_components";
import * as yup from "yup";
import {Formik, Form as FormikForm} from "formik";
import {config, endpoints} from "../../utils2";
import {WhiteCard} from "./_components/WhiteCard";

export function ActivateDevice() {
    return <AddDeviceRedirect/>
}

function AddDeviceRedirect() {

    return <AddDeviceForm/>
}

function AddDeviceForm() {
    const [searchParams, setSearchParams] = useSearchParams()

    const {uid} = useParams()
    const {authToken} = useAuth()
    const navigate = useNavigate()

    // Device actions
    const [sendData, _2, postLoading, postError, clearPostError] = usePostJson(endpoints.device.add(uid), authToken?.jwt)

    const search_iv = searchParams.get("iv")
    const search_data = searchParams.get("data")
    const search_tag = searchParams.get("tag")
    const search_sku = searchParams.get("sku")

    const model = search_sku || "Device"

    const initialValues = useMemo(() => ({
        iv: search_iv,
        data: search_data,
        tag: search_tag,
        name: "",
        // icon_id: null,
    }), [search_iv, search_data, search_tag, search_sku])

    const [prod, loadingProd, errorProd, clearErrorProd] = useGetJson(endpoints.product.query(model))
    const product = prod?.data
    const media_src = config.get_public_media(product?.medias[0].path, "medium")

    function handleOnSubmit(values, actions) {
        sendData(values, newValues => {
            actions.setSubmitting(false)
            navigate(`/device/${uid}/${newValues.data.device_class}`)
        })
    }

    const validationSchema = yup.object().shape({
        iv: yup.string().required("Key is missing."),
        data: yup.string().required("Label is missing."),
        tag: yup.string().required("Tag is missing."),
        name: yup.string().required("Name is required."),
        // icon_id: yup.string().required("An icon is missing."),
    })

    return <Stack className="my-2">
        <AdminUserAlert/>
        <Alert variant="danger" show={postError} dismissible onClose={clearPostError}>{postError}</Alert>

        <PageTitle title={`Activate ${model}`}>Use the form below to activate your device.</PageTitle>

        <div className="text-center">
            {media_src ? <img
                src={media_src}
                alt="Device"
                height="250px"
                width="250px"
                style={{borderRadius: "8px", minWidth: "60px"}}
                loading="lazy"
                className="mb-0"
            /> : null}
        </div>

        <Formik validationSchema={validationSchema} onSubmit={handleOnSubmit}
                initialValues={initialValues} enableReinitialize={true}>
            {({isSubmitting, resetForm}) => (
                <FormikForm className="">

                    <WhiteCard >
                        {/*<div className="text-center">*/}
                        {/*    {media_src ? <img*/}
                        {/*        src={media_src}*/}
                        {/*        alt="Device"*/}
                        {/*        height="180px"*/}
                        {/*        width="180px"*/}
                        {/*        style={{borderRadius: "8px", minWidth: "60px"}}*/}
                        {/*        loading="lazy"*/}
                        {/*        className="mb-0"*/}
                        {/*    /> : null}*/}
                        {/*</div>*/}
                        <SingleText name="name" label="Name" maxLength="64" placeholder="Device Name" className="flex-grow-1" autoFocus={true}/>
                    </WhiteCard>
                    {/*<div className="d-flex flex-wrap gap-2">*/}
                    {/*    <SingleText name="name" label="Name" maxLength="64" placeholder="Awesome player 3" className="flex-grow-1"/>*/}

                    {/*    <Field name="icon_id">*/}
                    {/*        {({field, meta}) =>*/}
                    {/*            <Form.Group controlId="icon">*/}
                    {/*                <Stack>*/}
                    {/*                    <Form.Label column="">Icon</Form.Label>*/}
                    {/*                    <Form.Control type="hidden" isInvalid={meta.touched && !!meta.error}/>*/}
                    {/*                    <ModalSelectIcon onChange={id => setFieldValue(field.name, id)} value={field.value}/>*/}
                    {/*                    <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>*/}
                    {/*                </Stack>*/}
                    {/*            </Form.Group>*/}
                    {/*        }*/}
                    {/*    </Field>*/}
                    {/*</div>*/}

                    {!(search_iv || search_data || search_tag) && <>
                        <WhiteCard>
                            <div className="fs-5 mb-2 fw-semibold">Identity</div>
                            <ColumnizeText>
                                <SingleText name="iv" label="Key" maxLength="16" disabled={search_iv}/>
                                <SingleText name="data" label="Label" maxLength="24" disabled={search_data}/>
                                <SingleText name="tag" label="Tag" maxLength="24" disabled={search_tag}/>
                            </ColumnizeText>
                        </WhiteCard>
                    </>}

                    <div className="mt-4"/>
                    <div>Grow your network! Explore and purchase new devices. <Link to="/shop">Visit our shop</Link></div>

                    <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                        <Button type="reset" variant="secondary" onClick={resetForm}>Reset</Button>
                        <Button type="submit" variant="primary" disabled={isSubmitting}>Activate</Button>
                    </Stack>
                </FormikForm>
            )}
        </Formik>

    </Stack>
}
